module.exports = __webpack_public_path__ + "media/images/icon-benefits-hmo-563d068bc70f5f53c541a9c224831eef.png";